import { FirebaseAnalyticsRepository } from '../../services/implementations/FirebaseAnalyticsRepository';
import { LogEventUseCase } from '../log-event-use-case';

export const logEventFactory = new LogEventUseCase(
  new FirebaseAnalyticsRepository()
);
